import { create } from "zustand";

// Helper function to load booking data from localStorage
const loadBookingDataFromStorage = () => {
  try {
    const savedBookingData = localStorage.getItem('bookingData');
    if (savedBookingData) {
      const parsedData = JSON.parse(savedBookingData);
      console.log('Booking data loaded from localStorage:', parsedData);
      return parsedData;
    }
  } catch (error) {
    console.error('Error parsing saved booking data:', error);
    localStorage.removeItem('bookingData');
  }
  return null;
};

const useBooking = create((set, get) => ({
  // Initialize with data from localStorage
  bookingData: loadBookingDataFromStorage(),

  saveBookingData: (data) => {
    try {
      localStorage.setItem('bookingData', JSON.stringify(data));
      console.log('Booking data saved:', data);
      set({ bookingData: data });
    } catch (error) {
      console.error('Error saving booking data:', error);
    }
  },

  clearBookingData: () => {
    try {
      localStorage.removeItem('bookingData');
      set({ bookingData: null });
    } catch (error) {
      console.error('Error clearing booking data:', error);
    }
  },
}));

export default useBooking; 